/* eslint-disable react/no-unused-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import axios from '../../../utils/axios';
import { queryStringBuilder } from '../../../utils/helpers';
import Spinner from '../Spinner/Spinner';
import globals from '../../../globals/communityGlobals';

const locale = globals.getArea('activities');
const styles = {
  totalTime: { paddingLeft: '20px' },
};
class ActivitiesSummary extends React.Component {
  state = {
    summary: null,
    isFetching: false,
  };

  async componentDidMount() {
    const { activitiesIds } = this.props;
    if (activitiesIds && activitiesIds.length) {
      await this.callApi(this.props);
    }
  }

  componentWillReceiveProps = async nextProps => {
    const { activitiesIds, activityVarianceIds } = nextProps;

    if (activitiesIds && activitiesIds.length) {
      if (
        this.needUpldate(activitiesIds, this.props.activitiesIds) ||
        this.needUpldate(activityVarianceIds, this.props.activityVarianceIds)
      ) {
        await this.callApi(nextProps);
      } else {
        this.setState({
          isFetching: false,
        });
      }
    } else {
      this.setState({
        summary: null,
      });
    }
  };

  needUpldate = (values, oldValues) =>
    values &&
    values.length &&
    (values.length !== oldValues.length || values.some((el, index) => el !== oldValues[index]));

  callApi = async ({ activitiesIds, jwtToken, handleApiError, activityVarianceIds }) => {
    this.setState({
      summary: null,
      isFetching: true,
    });

    try {
      const response = await axios.get(
        `v1/query/GetActivitiesSummary${queryStringBuilder({ activitiesIds, activityVarianceIds })}`,
        {
          headers: {
            Authorization: `Bearer ${jwtToken}`,
          },
        },
      );
      this.setState({
        summary: response.data,
        isFetching: false,
      });
      this.props.callback();
    } catch (error) {
      handleApiError(error);
    }
  };

  render() {
    const { summary, isFetching } = this.state;
    if (isFetching) {
      return <Spinner />;
    }

    if (!summary) {
      return <div className="activity-summary">{locale.getMsg('selectActivitiesToSeeSummary')}.</div>;
    }

    return (
      <div className="activity-summary">
        <span>
          {locale.getMsg('highestBand')}: {summary.highestGrade}
        </span>
        <span style={styles.totalTime}>
          {locale.getMsg('totalTime')}: {summary.totalDuration}
        </span>
      </div>
    );
  }
}

ActivitiesSummary.defaultProps = {
  activityVarianceIds: [],
  callback: () => {},
};

ActivitiesSummary.propTypes = {
  activitiesIds: PropTypes.arrayOf(PropTypes.number).isRequired,
  activityVarianceIds: PropTypes.arrayOf(PropTypes.number),
  jwtToken: PropTypes.string.isRequired,
  handleApiError: PropTypes.func.isRequired,
  callback: PropTypes.func,
};

export default ActivitiesSummary;
